<template>
  <b-container id="informations" :style="cssProps">
    <div class="header inner-shadow-box">
      <router-link to="/"><b-img :src='"/img/"+$path+"logo_minus_text.png"' fluid alt="Logo Estimair" id="estimair-logo"></b-img><b-img :src='"/img/"+$path+"logo-business.png"' fluid alt="Logo" id="logo-business"></b-img></router-link>
    </div>
    <div class="arianne">
      <p><router-link to="/">Accueil</router-link> <span class='decoration'>></span> <router-link :to="prev">Config</router-link> <span class='decoration'>></span> <router-link to="/list">{{list_label}}</router-link> <span class='decoration'>></span> <router-link to="/options">Accessoires</router-link> <span class='decoration'>></span> <span class='selected'>Données</span> <span class='decoration'>></span> PDF</p>
    </div>
    <h3>Renseignez vos information pour la génération du devis</h3>
    <b-form @submit="next($event)">
    <b-row class="justify-content-md-center">
      <b-col cols="12" md="6" lg="5" >
        <p v-if="errors.length">
          <b>Merci de corriger le/les champs incorrects:</b>
          <ul>
            <li v-for="(error,index) in errors" :key="index">{{ error }}</li>
          </ul>
        </p>
        <b-form-input v-model="form.departement" list="departement_list" placeholder="Département" required></b-form-input>
        <datalist id="departement_list">
          <option v-for="dep in departement" :key="dep.value">{{dep.value}} - {{ dep.text }}</option>
        </datalist>
        <b-form-input v-model="form.devis_fait_par" placeholder="Devis demandé par" required></b-form-input>
        <b-form-input type="email" v-model="form.mail" placeholder="Mail de réception du devis" required></b-form-input>
        <VuePhoneNumberInput v-model="telephone"
          :translations="translatePhone"
          default-country-code="FR"
          :preferred-countries="prefPhone"
          @update="validateTel($event)"
          id="telephone_custom"
        />
      </b-col>
    </b-row>
      <b-row class="footer align-items-between no-gutters" style="margin-top:1em">
        <b-col md="2" cols="6" order="2" order-md="1" style="text-align:left;">
          <b-button @click="$router.go(-1)">
            <img :src='"/img/"+$path+"arrow_left_footer.png"'/>
          </b-button>
        </b-col>
        <b-col md="8" cols="12" order="1" order-md="2" class="content inner-shadow-box">
          <div class="content-block">
            <p>S&amp;P France certifie que vos données ne seront jamais utilisées à des fin commerciales.</p>
          </div>
        </b-col>
        <b-col md="2" cols="6" order="3" order-md="3" style="text-align:right;">
          <b-button type="submit" class="next">
            <img :src='"/img/"+$path+"arrow_left_footer.png"'/>
          </b-button>
        </b-col>
      </b-row>
    </b-form>
  </b-container>
</template>

<script>
import VuePhoneNumberInput from 'vue-phone-number-input';
import 'vue-phone-number-input/dist/vue-phone-number-input.css';
export default {
  name: 'Informations',
  components: {
    VuePhoneNumberInput,
  },
  data() {
      return {
        translatePhone: {countrySelectorLabel: 'Code pays',countrySelectorError: 'Choisir un pays',phoneNumberLabel: 'Numéro de téléphone',example: 'Exemple :'},
        prefPhone: ['FR', 'BE', 'DE'],
        errors: [],
        valid_tel:true,
        valid_tel_demandeur:true,
        telephone_demandeur: null,
        telephone: null,
        show: true,
        list_label: 'Choix VMC',
        classic: true,
        departement: [{"value":"01","text":"Ain"},{"value":"02","text":"Aisne"},{"value":"03","text":"Allier"},{"value":"04","text":"Alpes-de-Haute-Provence"},{"value":"05","text":"Hautes-Alpes"},{"value":"06","text":"Alpes-Maritimes"},{"value":"07","text":"Ardèche"},{"value":"08","text":"Ardennes"},{"value":"09","text":"Ariège"},{"value":10,"text":"Aube"},{"value":11,"text":"Aude"},{"value":12,"text":"Aveyron"},{"value":13,"text":"Bouches-du-Rhône"},{"value":14,"text":"Calvados"},{"value":15,"text":"Cantal"},{"value":16,"text":"Charente"},{"value":17,"text":"Charente-Maritime"},{"value":18,"text":"Cher"},{"value":19,"text":"Corrèze"},{"value":"2A","text":"Corse-du-Sud"},{"value":"2B","text":"Haute-Corse"},{"value":21,"text":"Côte-d'Or"},{"value":22,"text":"Côtes d'Armor"},{"value":23,"text":"Creuse"},{"value":24,"text":"Dordogne"},{"value":25,"text":"Doubs"},{"value":26,"text":"Drôme"},{"value":27,"text":"Eure"},{"value":28,"text":"Eure-et-Loir"},{"value":29,"text":"Finistère"},{"value":30,"text":"Gard"},{"value":31,"text":"Haute-Garonne"},{"value":32,"text":"Gers"},{"value":33,"text":"Gironde"},{"value":34,"text":"Hérault"},{"value":35,"text":"Ille-et-Vilaine"},{"value":36,"text":"Indre"},{"value":37,"text":"Indre-et-Loire"},{"value":38,"text":"Isère"},{"value":39,"text":"Jura"},{"value":40,"text":"Landes"},{"value":41,"text":"Loir-et-Cher"},{"value":42,"text":"Loire"},{"value":43,"text":"Haute-Loire"},{"value":44,"text":"Loire-Atlantique"},{"value":45,"text":"Loiret"},{"value":46,"text":"Lot"},{"value":47,"text":"Lot-et-Garonne"},{"value":48,"text":"Lozère"},{"value":49,"text":"Maine-et-Loire"},{"value":50,"text":"Manche"},{"value":51,"text":"Marne"},{"value":52,"text":"Haute-Marne"},{"value":53,"text":"Mayenne"},{"value":54,"text":"Meurthe-et-Moselle"},{"value":55,"text":"Meuse"},{"value":56,"text":"Morbihan"},{"value":57,"text":"Moselle"},{"value":58,"text":"Nièvre"},{"value":59,"text":"Nord"},{"value":60,"text":"Oise"},{"value":61,"text":"Orne"},{"value":62,"text":"Pas-de-Calais"},{"value":63,"text":"Puy-de-Dôme"},{"value":64,"text":"Pyrénées-Atlantiques"},{"value":65,"text":"Hautes-Pyrénées"},{"value":66,"text":"Pyrénées-Orientales"},{"value":67,"text":"Bas-Rhin"},{"value":68,"text":"Haut-Rhin"},{"value":69,"text":"Rhône"},{"value":70,"text":"Haute-Saône"},{"value":71,"text":"Saône-et-Loire"},{"value":72,"text":"Sarthe"},{"value":73,"text":"Savoie"},{"value":74,"text":"Haute-Savoie"},{"value":75,"text":"Paris"},{"value":76,"text":"Seine-Maritime"},{"value":77,"text":"Seine-et-Marne"},{"value":78,"text":"Yvelines"},{"value":79,"text":"Deux-Sèvres"},{"value":80,"text":"Somme"},{"value":81,"text":"Tarn"},{"value":82,"text":"Tarn-et-Garonne"},{"value":83,"text":"Var"},{"value":84,"text":"Vaucluse"},{"value":85,"text":"Vendée"},{"value":86,"text":"Vienne"},{"value":87,"text":"Haute-Vienne"},{"value":88,"text":"Vosges"},{"value":89,"text":"Yonne"},{"value":90,"text":"Territoire de Belfort"},{"value":91,"text":"Essonne"},{"value":92,"text":"Hauts-de-Seine"},{"value":93,"text":"Seine-St-Denis"},{"value":94,"text":"Val-de-Marne"},{"value":95,"text":"Val-D'Oise"},{"value":971,"text":"Guadeloupe"},{"value":972,"text":"Martinique"},{"value":973,"text":"Guyane"},{"value":974,"text":"La Réunion"},{"value":976,"text":"Mayotte"}]
      }
    },
    methods: {
      next(evt) {
        evt.preventDefault();
        this.errors = [];
        let validate = true;

        if(!this.validEmail(this.form.mail)){
          this.errors.push("L'adresse e-mail n'est pas valide.");
          validate = false;
        }

        if(!this.valid_tel){
          this.errors.push("Le numéro de téléphone est mal formaté.");
          validate = false;
        }
        if(validate){
          this.$store.dispatch('devis/setInformations',this.form);
          console.log(this.$store.state.devis.devis);
          const baseURI = this.$api_url+'devis'
          this.$http.post(baseURI,{'devis':this.$store.state.devis.devis})
          .then((result) => {
            if(result){
              console.log(result.data);
              this.$store.dispatch('devis/setPDF',result.data);
              console.log(this.$store.state.devis.devis);
              this.$router.push('devis');
            }

          })
        }
      },
      validSiret(number){
        if (isNaN(number) || number.length!=14) return false;
        var bal = 0;
        var total = 0;
        for (var i=14-1; i>=0; i--){
            var step = (number.charCodeAt(i)-48)*(bal+1);
            /*if (step>9) { step -= 9; }
             total += step;*/
            total += (step>9)?step-9:step;
            bal = 1-bal;
        }
        return (total%10==0)?true:false;
      },
      validEmail(email) {
        var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(email);
      },
      validateTel(ev){
        console.log(ev);
        this.valid_tel = ev.isValid
        this.form.telephone = ev.e164;
      },
      validateDemandeurTel(ev){
        console.log(ev);
        this.valid_tel_demandeur = ev.isValid;
        this.form.telephone_demandeur = ev.e164;
      },
      setTelephone(state){
        this.telephone_demandeur = state['telephone_demandeur'];
        this.telephone = state['telephone'];
      },
    },
    computed: {
    cssProps() {
        return {
          '--maincolor': this.$maincolor
        }
      },
      prev() {
        let res = '/'
        console.log("Back");
        switch(this.$store.state.devis.devis['type']){
          case "individuel":
            res = '/individuel';
          break;
          case 'collectif':
            res = '/collectif';
          break;
          case 'desenfumage':
            res = '/desenfumage';
          break;
          default:
          break;
        }
        return res;
      },
      form() {
        let state = {};
        if(this.$store.state.devis && this.$store.state.devis.devis && this.$store.state.devis.devis['informations']!=undefined){
          state = this.$store.state.devis.devis['informations'];
          this.setTelephone(state);
        }else{
          state['ref_chantier'] = "";
          state['siret'] = "";
          state['departement'] = null;
          state['ville'] = "";
          state['distributeur'] = "";
          state['devis_fait_par'] = "";
          state['mail'] = "";
          state['telephone'] = "";
          state['demandeur'] = "";
          state['mail_demandeur'] = "";
          state['telephone_demandeur'] = "";
        }
        return state;
      },
    },mounted(){
      window.scrollTo(0, 0);
      console.log(this.$store.state.products.products);
      console.log(this.$store.state.devis.devis);
      switch(this.$store.state.devis.devis['type']){
          case 'desenfumage':
            this.list_label = 'Choix Volet';
            this.classic = false;
          break;
          default:
            this.list_label = 'Choix VMC';
            this.classic = true;
          break;
      }
    }
}
</script>

<style lang="scss" scoped>

#informations{
  text-align: left;
  max-width: 1980px;
  margin: 2em auto;

  @media (max-width: 576px) {
      padding:0;
  }
  input,select,#telephone_custom {
    margin-bottom:2em;
    background-color: transparent;
    border-radius: 2em;
    border:0px;
    box-shadow: inset 5px 5px 5px 0px rgba(0,0,0,0.3), inset 4px 4px 15px 0px #fff;
    color: #000;
    padding: 1.5em 1em;
    &::placeholder {
      color:#999;
    }
  }

  h3{
    margin-bottom:1em;
  }
}
</style>
